
import {Component, Prop, Vue} from 'vue-property-decorator';
import {Stamp} from "@/store";
import moment from 'moment';

@Component
export default class Results extends Vue {
  @Prop() private msg!: string;

  get stamp(): Stamp {
    return this.$store.getters.stamp
  }

  get isLoading(): boolean {
    return this.$store.getters.isLoading
  }

  get isFound(): boolean {
    return this.$store.getters.isFound
  }

  get resultBackgroundVariant(): string {
    return this.isValid ? 'success' : 'danger';
  }

  invalidate() {
    this.$store.dispatch('invalidate')
  }

  get purchaseDate(): moment.Moment {
    return moment.unix(parseInt(this.stamp.purchaseDate))
  }

  get expirationDate(): moment.Moment {
    return moment.unix(parseInt(this.stamp.purchaseDate)).add(15, 'days')
  }

  get isInvalid(): boolean {
    return !this.stamp.valid;
  }

  get isExpired(): boolean {
    return this.purchaseDate.isAfter(moment.utc()) || this.expirationDate.isBefore(moment.utc());
  }

  get isValid(): boolean {
    return !this.isExpired && !this.isInvalid;
  }
}
